import { useContext, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Context as FormContext } from "../../context/formContext/FormContext";
import {
  TemperatureRange,
  TemperatureSelectType,
} from "../../context/formContext/types";
import { Context as SuggestionContext } from "../../context/suggestionContext/SuggestionContext";
import { SuggestionResult } from "../../context/suggestionContext/types";
import Suggestions from "./Suggestions/Suggestions";

const SuggestionsContainer = () => {
  const {
    state: suggestionState,
    getClothesSuggestions,
    restoreSuggestions,
  } = useContext(SuggestionContext);
  const { suggestions, result } = suggestionState;

  const { state: formState } = useContext(FormContext);
  const { i18n } = useTranslation();

  useEffect(() => {
    /* getClothesSuggestions(2, [18, 22], 50, 1, 0); */

    return () => {};
  }, []);

  useEffect(() => {
    if (formState.temperatureValue) {
      const location = formState.activity?.location!;
      let temperatureValue, temp;
      const humidity = 50;
      const ageGroup = formState.ageLocationPair?.ageGroup[0]!;
      const sweatComment =
        formState.activity?.sweatComment === null ||
        formState.activity?.sweatComment === undefined
          ? 0
          : formState.activity?.sweatComment;

      switch (formState.temperatureSelectType) {
        case TemperatureSelectType.RANGE:
          temperatureValue = formState.temperatureValue
            .temperature as TemperatureRange;
          temp = [
            temperatureValue.temperature[0],
            temperatureValue.temperature[1],
          ];

          getClothesSuggestions(
            location,
            temp,
            humidity,
            ageGroup,
            sweatComment
          );

          break;

        case TemperatureSelectType.SLIDER:
          temperatureValue = formState.temperatureValue.temperature as number;
          temp = [temperatureValue, temperatureValue];

          getClothesSuggestions(
            location,
            temp,
            humidity,
            ageGroup,
            sweatComment
          );

          break;
        default:
          break;
      }
    } else {
      restoreSuggestions();
    }

    return () => {};
  }, [formState]);

  return (
    <div className="suggestions-container">
      <h5 className="input-label">{i18n.t("form_our_suggestions")}</h5>

      {result !== SuggestionResult.RESTORE ? (
        <Suggestions></Suggestions>
      ) : (
        <p className="input-description">
          {i18n.t("first_fill_prev_sections")}
        </p>
      )}
    </div>
  );
};

export default SuggestionsContainer;
